import React from 'react';

const ArrowIcon = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_b_50_2088)">
      <rect
        width="32"
        height="32"
        rx="16"
        fill="#171717"
        fillOpacity="0.4"
      />
      <path
        d="M22.8776 14.111L22.8762 14.1117L22.8691 14.1189L16.6191 20.3689L16.619 20.3689C16.5377 20.4505 16.4411 20.5152 16.3347 20.5594C16.2284 20.6036 16.1143 20.6263 15.9992 20.6263C15.884 20.6263 15.77 20.6036 15.6636 20.5594C15.5573 20.5152 15.4607 20.4505 15.3794 20.3689L15.3793 20.3689L9.12932 14.1189C8.96492 13.9545 8.87256 13.7315 8.87256 13.499C8.87256 13.2665 8.96492 13.0435 9.12932 12.8791C9.29372 12.7147 9.51669 12.6224 9.74918 12.6224C9.98168 12.6224 10.2047 12.7147 10.3691 12.8791L15.9558 18.4658L16 18.51L16.0442 18.4658L21.6309 12.8783C21.7953 12.7139 22.0183 12.6216 22.2507 12.6216C22.4832 12.6216 22.7062 12.7139 22.8706 12.8783C23.035 13.0427 23.1274 13.2657 23.1274 13.4982C23.1274 13.7274 23.0376 13.9473 22.8776 14.111Z"
        fill="white"
        stroke="white"
        strokeWidth="0.125"
      />
    </g>
    <defs>
      <filter
        id="filter0_b_50_2088"
        x="-17"
        y="-17"
        width="66"
        height="66"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feGaussianBlur
          in="BackgroundImageFix"
          stdDeviation="8.5"
        />
        <feComposite
          in2="SourceAlpha"
          operator="in"
          result="effect1_backgroundBlur_50_2088"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_backgroundBlur_50_2088"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ArrowIcon;
